import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../../feature'
import type { Feature } from '../feature'

/** Starts a sibling-user lookup when the active portal context changes. */
export const startGet = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    rxjs
      .combineLatest({
        appContext: meFeature.contexts.selectors.appContext.asObservable,
        scenarioContext:
          meFeature.contexts.selectors.scenarioContext.asObservable,
        zoneContext: meFeature.contexts.selectors.zoneContext.asObservable,
      })
      .pipe(
        rxjs.map(
          ({ appContext, scenarioContext, zoneContext }) =>
            scenarioContext ?? appContext ?? zoneContext,
        ),
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.filter(TypeChecker.isNotNullish),
        // The active context determines which sibling users are requested. If
        // a caller needs zone users while in an app, or app users while in a
        // scenario, extend `get` with an explicit target-context input rather
        // than changing this current-context flow. Do not implement that
        // alternative behavior until a caller requires it.
        rxjs.map(() =>
          feature.actions.get.from('SiblingUsers.Context.Changed').create(),
        ),
      ),
)
